import React, { createContext, useContext, useState } from 'react';

const NavContext = createContext();

export const NavProvider = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const triggerRefresh = () => {
    setRefreshKey(prev => prev + 1);
    setIsLoading(true);
  };

  const setLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <NavContext.Provider value={{ refreshKey, triggerRefresh, isLoading, setLoadingComplete }}>
      {children}
    </NavContext.Provider>
  );
};

export const useNavRefresh = () => useContext(NavContext);
